import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { GetAllRoutesResponse, MbapiAdminService, Route } from 'src/Services/API';

import { QueryKeys } from '../types';

export const useToggleRoute = (
  extraOptions?: UseMutationOptions<void, AxiosError, { route: Route; username: string }>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ route, username }) => {
      if (route.usernames.includes(username))
        await MbapiAdminService.mbapiAdminControllerRemoveUsersFromRoute({
          body: {
            method: route.method,
            path: route.path,
            usernames: [username],
          },
        });
      else
        await MbapiAdminService.mbapiAdminControllerAddUsersOnRoute({
          body: {
            method: route.method,
            path: route.path,
            usernames: [username],
          },
        });
    },
    {
      ...extraOptions,
      onSuccess: (data, variables, context) => {
        queryClient.setQueryData<GetAllRoutesResponse>([QueryKeys.getAllRoutes], data => {
          if (!data) return;
          return {
            users: data.users,
            routes: data.routes.map(route => {
              if (route.method === variables.route.method && route.path === variables.route.path)
                return {
                  ...route,
                  usernames: route.usernames.includes(variables.username)
                    ? route.usernames.filter(username => username !== variables.username)
                    : [...route.usernames, variables.username],
                };
              return route;
            }),
          };
        });
        queryClient.invalidateQueries([QueryKeys.getAllRoutes]);
        extraOptions?.onSuccess?.(data, variables, context);
      },
    }
  );
};
